import { gql } from '@/__generated__';

export const GET_LAST_CONNECTION_STATE = gql(`#graphql
  query GetLastConnectionState($movementId: String!) {
    gateMovement(id: $movementId) {
      gate {
        id
        mainDevice {
          id
          metrics {
            id
            connectionState {
              lastData
            }
          }
        }
      }
    }
  }
`);
